import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { StyledAppIFrame, StyledAppIFrameFullScreen } from "./index.styled";
import AppLoader from "_lib/AppLoader";
import AppError from "_lib/AppError";
import { useFullScreen } from "_hooks";
import { AppBreadcrumbs } from "_lib";

const AppIFrame = (props) => {
  const {
    url,
    title,
    loading = false,
    error = false,
    includeIFrameLoad = false,
    lottieAnimationData = null,
    lottieClassName = "lottie-loading",
    lottieSize = 300,
    lottie = false,
    position = "absolute",
    height = "100%",
    urlToNameMap = {},
  } = props;

  const { handle, onClickFullScreen } = useFullScreen();

  const [iframeLoading, setIframeLoading] = useState(includeIFrameLoad);

  const handleIFrameLoad = useCallback(() => {
    if (!includeIFrameLoad) return;
    setIframeLoading(false);
  }, [includeIFrameLoad]);

  if (error)
    return (
      <AppError
        showRefreshButton
        description={
          "Game not available. Please refresh the page or try again later"
        }
      />
    );
  return (
    <>
      <AppBreadcrumbs
        showFullScreen
        onClickFullScreen={onClickFullScreen}
        urlToNameMap={urlToNameMap}
      />
      {iframeLoading || loading ? (
        <AppLoader
          position={position}
          height={height}
          lottieAnimationData={lottieAnimationData}
          lottieClassName={lottieClassName}
          lottieSize={lottieSize}
          lottie={lottie}
        />
      ) : null}
      <StyledAppIFrameFullScreen handle={handle}>
        <StyledAppIFrame
          src={url}
          title={title}
          allowFullScreen
          onLoad={handleIFrameLoad}
          loading="lazy"
          allow="autoplay; clipboard-write"
        />
      </StyledAppIFrameFullScreen>
    </>
  );
};

AppIFrame.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.bool,
  includeIFrameLoad: PropTypes.bool,
  position: PropTypes.string,
  height: PropTypes.string,
  lottieAnimationData: PropTypes.object,
  lottieClassName: PropTypes.string,
  lottieSize: PropTypes.number,
  lottie: PropTypes.bool,
  urlToNameMap: PropTypes.object,
};

export default AppIFrame;
